import React from 'react';

import Navbar from '@organisms/Navbar/Navbar';

import Redirect from '@molecules/Redirect/Redirect';

import Loader from '@atoms/Loader/Loader';

import useEndpoint from '@hooks/useEndpoint';

import colors from '@utils/colors';

import privateOptions from '@config/privateOptions';

import { Container } from './styles';

export const AppContext = React.createContext(null);

const PrivateRoutes = ({ children }) => {
  const token = localStorage.getItem('$$token');

  const [userdata] = useEndpoint('/admin/current-user', {
    headers: {
      Authorization: token,
    },
  });

  if (!token || userdata.isError) {
    return <Redirect to="/account/login" />;
  }

  if (!userdata.data) {
    return (
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: colors.mediumBlack,
          padding: '15px',
          borderRadius: '15px',
          zIndex: 2,
        }}
      >
        <Loader
          theme="primary-orange"
          size="medium"
          style={{ alignSelf: 'center' }}
        />
      </div>
    );
  }

  const options = getRouteOptions();

  const appState = {
    token,
    ...options,
    ...userdata.data,
  };

  localStorage.setItem('$$isAdmin', userdata?.data?.isAdmin);

  return (
    <div>
      <Navbar activeRoute={window.location.pathname} />
      <AppContext.Provider value={appState}>
        <Container>{children(options.privateOptions)}</Container>
      </AppContext.Provider>
    </div>
  );
};

const getRouteOptions = () => {
  return {
    privateOptions,
  };
};

export default PrivateRoutes;
